import { Asset } from '../..';
import { fixedIncomeSellOffersQueryUpdated } from '../../../../../../../../store/product/selectors';

import { FixedIncomeListItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const FixedIncomeSellAsset = () => {
  return (
    <Asset
      productsQuery={fixedIncomeSellOffersQueryUpdated}
      ProductItem={FixedIncomeListItem}
      ProductItemLoading={ListLoadingItem}
      keySelector="productIdNormalized"
    />
  );
};
